import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import purify from "dompurify";
import { autoLogin as autoLoginAction } from "../../reducers/authorizeSlice";
import { useAppDispatch } from "../../store/configureStore";

const AutoLogin = () => {
  const dispatch = useAppDispatch();

  const autoLogin = (token) => dispatch(autoLoginAction(token));

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = purify.sanitize(params.get("token") || undefined);

  if (token) {
    autoLogin(JSON.parse(token));

    return <Redirect to="/" />;
  }

  return <span>Sorry, invalid read-only token</span>;
};

AutoLogin.propTypes = {
  autoLoginAction: PropTypes.func.isRequired,
};

export default AutoLogin;
